import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicAdmissionType1 } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AT_ADMISSION_TYPE_1_CONDITION_ID = 'admissionType1AT';
export const AtFilterConditionAdmissionType1PluginType: FilterConditionPluginSpecification<
  AtVirtualClinicAdmissionType1[],
  AtFilterConditionAdmissionType1Dto,
  AtAdmissionType1Condition
> = {
  type: 'admissionType1',
  category: 'case',
  displayName: { de: 'Aufnahmeart 1' },
  sortingIndex: 2,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionAdmissionType1Dto,
  ): FilterConditionPluginImpl<AtVirtualClinicAdmissionType1[]> {
    return new AtFilterConditionAdmissionType1Plugin(obj.admissionType1);
  },
  fromCondition(
    jsonObj: AtAdmissionType1Condition,
  ): FilterConditionPluginImpl<AtVirtualClinicAdmissionType1[]> {
    return new AtFilterConditionAdmissionType1Plugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicAdmissionType1[]> {
    return new AtFilterConditionAdmissionType1Plugin([]);
  },
};

export class AtFilterConditionAdmissionType1Plugin extends FilterConditionPluginImpl<
  AtVirtualClinicAdmissionType1[],
  AtFilterConditionAdmissionType1Dto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicAdmissionType1[],
    AtFilterConditionAdmissionType1Dto,
    AtAdmissionType1Condition
  > = AtFilterConditionAdmissionType1PluginType;

  constructor(protected admissionType1: AtVirtualClinicAdmissionType1[]) {
    super(AtFilterConditionAdmissionType1PluginType.type);
  }

  clone(): AtFilterConditionAdmissionType1Plugin {
    return new AtFilterConditionAdmissionType1Plugin([...this.admissionType1]);
  }

  override equals(other: AtFilterConditionAdmissionType1Plugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(this.admissionType1, other.admissionType1)
    );
  }

  override validationToText(): string {
    if (this.admissionType1.length === 0) {
      return 'Mindestens eine Aufnahmeart auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AtAdmissionType1Condition(this.admissionType1, []);
  }

  toText(): string | null {
    return this.admissionType1.length === 1
      ? 'eine Aufnahmeart 1'
      : `${this.admissionType1.length} Aufnahmearten 1`;
  }

  toJSON(): AtFilterConditionAdmissionType1Dto | null {
    return {
      type: this.type,
      admissionType1: this.admissionType1,
    };
  }

  toValue(): AtVirtualClinicAdmissionType1[] {
    return this.admissionType1;
  }
}

export class AtAdmissionType1Condition extends BdContentCondition<AtVirtualClinicAdmissionType1> {
  constructor(
    includes: AtVirtualClinicAdmissionType1[],
    excludes: AtVirtualClinicAdmissionType1[],
  ) {
    super(AT_ADMISSION_TYPE_1_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionAdmissionType1Dto {
  type: string;
  admissionType1: AtVirtualClinicAdmissionType1[];
}
